import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Redirect, Link } from 'react-router-dom';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { Spinner } from '../../uiComponents/Spinner';
import { ErrorWrapper } from '../../uiComponents/ErrorWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';

export interface TilmeldingAccepterInvitationProps extends RouteComponentProps<any> {
}

interface TilmeldingAccepterInvitationState {
    isLoading: boolean;
    validationResult?: ValidationResult;
}

class TilmeldingAccepterInvitation extends React.Component<TilmeldingAccepterInvitationProps, TilmeldingAccepterInvitationState> {
    constructor(props: TilmeldingAccepterInvitationProps) {
        super(props);

        this.state = { isLoading: true };
    }

    componentDidMount() {
        var self = this;
        const invitationsId = this.props.match.params.id;

        var invitationsPromise = createApiCaller().acceptTilmeldingInvitation(invitationsId);
        invitationsPromise.then(function (json: ValidationResult) {
            self.setState({ isLoading: false, validationResult: json });
        });
    }

    render() {
        if (this.state.isLoading) {
            return <Spinner />;
        }

        const validationError = this.state.validationResult !== undefined && this.state.validationResult !== null && !this.state.validationResult.isValid;

        if (!validationError) {
            NotificationQueue.push(new NotificationData('Du har accepteret invitationen og har nu adgang til konkurrencen', '', 'success'));
        }

        return (
            <PageWrapper>
                <PageTitle title='Acceptér' />
                <ContentWrapper>
                    {!validationError && <Redirect to='/' />}
                    {validationError &&
                        <SectionGroup>
                            <ErrorWrapper header='Angiv navn og e-mail'>
                                <p>Du kan ikke acceptere en invitation uden at have angivet navn og e-mail. </p>
                                <p>Ret dette under <Link to='/bruger-profil'>"Profil"</Link> for at komme videre.</p>
                            </ErrorWrapper>
                        </SectionGroup>
                    }
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default TilmeldingAccepterInvitation;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingAccepterInvitation.tsx